import { blockGameInput } from '../input.js';

// Blocking dialog box with a typewriter reveal.
// - Call `showDialog([{speaker, text}, ...])` — returns a Promise that resolves
//   once the player has advanced through every line.
// - First space / enter during typing skips to the full line.
// - Subsequent space / enter advances to the next line (with a small debounce
//   so the same keypress can't both skip and advance).

const TYPE_RATE_MS = 16;
const ADVANCE_DEBOUNCE_MS = 180;

let element = null;
let resolveAdvance = null;
let lastAdvance = 0;

function build() {
  const el = document.createElement('div');
  el.className = 'dialog hidden';
  el.innerHTML = `
    <div class="dialog-box">
      <span class="dialog-corner tl"></span>
      <span class="dialog-corner tr"></span>
      <span class="dialog-corner bl"></span>
      <span class="dialog-corner br"></span>
      <div class="dialog-speaker"></div>
      <div class="dialog-text">
        <span class="dialog-text-body"></span><span class="dialog-cursor"></span>
      </div>
      <div class="dialog-prompt">▸ space</div>
    </div>
  `;
  document.body.appendChild(el);
  return el;
}

export function initDialogUI() {
  element = build();
  addEventListener('keydown', (e) => {
    if (!resolveAdvance) return;
    if (e.key !== ' ' && e.key !== 'Enter') return;
    e.preventDefault();
    const now = performance.now();
    if (now - lastAdvance < ADVANCE_DEBOUNCE_MS) return;
    lastAdvance = now;
    resolveAdvance();
  });
}

function playLine(text) {
  return new Promise((resolve) => {
    const body = element.querySelector('.dialog-text-body');
    body.textContent = '';
    let i = 0;
    let done = false;
    const timer = setInterval(() => {
      body.textContent = text.slice(0, ++i);
      if (i >= text.length) {
        clearInterval(timer);
        done = true;
        element.classList.add('is-ready');
      }
    }, TYPE_RATE_MS);

    resolveAdvance = () => {
      if (!done) {
        // Skip — reveal full line, wait for the next press to advance.
        clearInterval(timer);
        body.textContent = text;
        done = true;
        element.classList.add('is-ready');
      } else {
        resolveAdvance = null;
        element.classList.remove('is-ready');
        resolve();
      }
    };
  });
}

export async function showDialog(lines) {
  if (!element) initDialogUI();
  element.classList.remove('hidden');
  blockGameInput(true);
  try {
    for (const line of lines) {
      element.querySelector('.dialog-speaker').textContent = line.speaker ?? '';
      await playLine(line.text);
    }
  } finally {
    element.classList.add('hidden');
    element.classList.remove('is-ready');
    blockGameInput(false);
  }
}
